import React from 'react';
import { connect } from 'react-redux';
import { Radio, SpacerVertical } from '@klarna/bubble-ui';
import { BusinessSize } from '@/bpc/mf-fields/enm/BusinessSize';
import { ErrorMessage } from '@/components/ErrorMessage';
import { getBpcPayload } from '@/selectors/bpc';
import { BusinessSizeLabel } from './BusinessSizeLabel';
export const _BusinessSizeComponent = ({ currency, rate, tiers, value, onChange, t, error, }) => {
    const options = Object.keys(tiers || {}).map(tier => ({
        value: BusinessSize[tier], // Map the object key string back to the enum key,
        label: (React.createElement(BusinessSizeLabel, { currency: currency, from: tiers[tier].from, to: tiers[tier].to, rate: rate, t: t })),
    }));
    return (React.createElement(React.Fragment, null,
        React.createElement(Radio, { error: error, onChange: onChange, value: value, options: options }),
        React.createElement(SpacerVertical, { spaceToken: "space.200" }),
        error ? React.createElement(ErrorMessage, { message: error }) : null));
};
export const BusinessSizeComponent = connect(state => ({ payload: getBpcPayload(state) }))(_BusinessSizeComponent);
